export const BACKEND_URL = 'http://localhost:3001'